import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowHyphen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 2,
	viewBox: "0 0 22 2",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 1C0 0.447715 0.447715 0 1 0H21C21.5523 0 22 0.447715 22 1C22 1.55228 21.5523 2 21 2H1C0.447716 2 0 1.55228 0 1Z",
		fill: "currentColor"
	})
});
export default SvgArrowHyphen;
